import type { PublicPath } from "@/components/site/LocaleLink";

/** Soorten werk voor een realisatie, met de bijbehorende dienstpagina. */
export const projectTypes = [
  { id: "bouwkundige-zwembaden", label: "Bouwkundige zwembaden", service: "/nieuwbouw" },
  { id: "renovatie-monoblock", label: "Renovatie monoblock", service: "/renovatie" },
  { id: "zwembadtechniek", label: "Zwembadtechniek", service: "/technieken" },
  { id: "lekdetectie", label: "Lekdetectie", service: "/technieken" },
  { id: "warmtepompen", label: "Warmtepompen", service: "/warmtepompen-afdekkingen" },
  { id: "afdekking", label: "Rolluiken & overkappingen", service: "/warmtepompen-afdekkingen" },
] as const satisfies readonly { id: string; label: string; service: PublicPath }[];

export type ProjectType = (typeof projectTypes)[number]["id"];

export function projectTypeLabel(id: string) {
  return projectTypes.find((type) => type.id === id)?.label ?? id;
}

export function projectTypeService(id: string): PublicPath {
  return projectTypes.find((type) => type.id === id)?.service ?? "/offerte";
}

/** Slug uit een titel: kleine letters, streepjes, geen accenten. */
export function slugify(input: string) {
  return input
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
}
